import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Main from './Main';
import 'helpers/initFA';
import { Provider } from 'react-redux';
import { store } from 'state/store';
import { GoogleOAuthProvider } from '@react-oauth/google';

const container = document.getElementById('main');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId="926218884311-s2n15kahubu4rv35876meh04conmp62r.apps.googleusercontent.com">
      <Provider store={store}>
        <Main>
          <App />
        </Main>
      </Provider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);
